// extracted by mini-css-extract-plugin
module.exports = {"heading":"RentalAgreementPage_heading__3xY5B","content":"RentalAgreementPage_content__2el_7"};